import {Col, Row, Tabs} from "antd";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";
import WaitingTransfer from "./waitingTransfer/WaitingTransfer";
import TransfersTable from "./transfersTable/TransfersTable";
import CompletedTransfers from "./completedTransfers/CompletedTransfers";
import {ActiveTransfers} from "./activeTransfers/ActiveTransfers";
const {TabPane} = Tabs;

const TransferPage = () => {
    const [currentTab, setCurrentTab] = useState("waiting");
    const history = useHistory();

    const changeTab = value => {
        let path = history.location.pathname;
        path += "?status=" + value;
        history.push(path);
    };

    useEffect(() => {
        if (history.location.search) {
            setCurrentTab(history.location.search.split("?status=")[1]);
        } else {
            changeTab("waiting");
        }
    }, [history.location.search]);

    return (
        <>
            <Row>
                <Col>
                    <Tabs activeKey={currentTab} onChange={changeTab}>
                        <TabPane
                            tab={"Planlanacak Sevkiyatlar"}
                            key="waiting"
                            data-testid="transferStep_tabPane"
                        >
                            <WaitingTransfer />
                        </TabPane>
                        <TabPane
                            tab={"Taslak Planlamaları"}
                            key="planning"
                            data-testid="transferStep_tabPane"
                        >
                            <TransfersTable />
                        </TabPane>
                        <TabPane
                            tab={"Tamamlanan Planlamalar"}
                            key="completed"
                            data-testid="transferStep_tabPane"
                        >
                            <CompletedTransfers />
                        </TabPane>
                    </Tabs>
                </Col>
            </Row>
        </>
    );
};

export default TransferPage;
